import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBXOg7Z4PgEGdstcl4ODByPrl0Z2EvwCNc",
  authDomain: "bunny-boutique-321.firebaseapp.com",
  projectId: "bunny-boutique-321",
  storageBucket: "bunny-boutique-321.firebasestorage.app",
  messagingSenderId: "473786442321",
  appId: "1:473786442321:web:1866262a5499dd2af18e70",
  measurementId: "G-66Z497J2GN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

// Export Auth and Database for use in other components
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);